import styles from "./WalletTokenCard.module.css";
import { getRandomArbitrary } from "../../../utils/general";
const WalletTokenCard = ({ token }) => {
  return (
    <div className={styles.token_container} key={token.token_address}>
      <div className={styles.token_info}>
        <div className={styles.image_name}>
          <img src={token.logoURI} alt="token" />
          <span className={styles.token_symbol}>{token?.symbol}</span>
        </div>
        <span className={styles.token_name}>{token?.name}</span>
      </div>

      <div className={styles.token_value}>{token?.value ? token?.value : getRandomArbitrary(0, 123000).toFixed(2)}</div>
      <span className={styles.token_amount}>
        {token.amount ? token.amount : 0.0}
      </span>
    </div>
  );
};

export default WalletTokenCard;
